export const urls = {
  auth: {
    resetPassword: "/auth/reset-password",
    resetPasswordToken: (token: string) => `/auth/reset-password/${token}`,
    verifyEmail: "/auth/verify-email",
    verifyEmailToken: (token: string) => `/api/verify-email/${token}`,
    signin: "/auth/signin",
    signup: "/auth/signup",
    signupCheckYourEmail: "/auth/signup/check-your-email",
    signupSetPassword: (token: string) => `/auth/signup/${token}`,
    invalidToken: "/auth/invalid-token",
  },
  app: {
    home: "/",

    sessions: "/sessions",
    sessionDetail: (sessionId: string) => `/sessions/${sessionId}`,
    sessionPhotoDetail: (sessionId: string, sessionPhotoId: string) => `/sessions/${sessionId}/${sessionPhotoId}`,

    claims: "/claims",
    claimDetail: (claimId: string) => `/claims/${claimId}`,

    reports: "/reports",
    reportDetail: (reportId: string) => `/reports/${reportId}`,

    accountSettings: "/account/settings",
  },
} as const
